import React                                   from 'react';
import { useTheme }                            from 'styled-components';
import CheckboxChecked                         from '@geenee/builder/src/asset/icons/CheckboxChecked';
import SupportIcon                             from '@geenee/builder/src/asset/icons/SupportIcon';
import Hint                                    from '@geenee/builder/src/components/common/Hint';
import { UnderlinedTableRow, WithHintWrapper } from '@geenee/builder/src/pages/AllPlansPage/styles';

export function PriorityTechnicalSupport() {
    const { secondaryColors } = useTheme();
    return (
        <UnderlinedTableRow>
            <td>
                <WithHintWrapper>
                    <span>Priority Technical Support</span>
                    { ' ' }
                    <Hint
                        title='We’ve got you covered'
                        text="Our tech support team is easy to reach and responsive."
                        iconElement={ <SupportIcon /> }
                    />
                </WithHintWrapper>

            </td>
            <td className='basic-plan' />
            <td className='plan-filler' />
            <td className='studio-plan' />
            <td className='plan-filler' />
            <td className='pro-plan'>
                { ' ' }
                <CheckboxChecked
                    beIcon
                    fill={ secondaryColors.green70 }
                />
            </td>
        </UnderlinedTableRow>
    );
}
